Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.loadPopularSuggestions = loadPopularSuggestions;
exports.executeQuery = executeQuery;
exports.setQueryOptions = setQueryOptions;
exports.updateQuery = updateQuery;
exports.loadMore = loadMore;
exports.loadDataToExport = loadDataToExport;

var _value = require('./value');

var _utils = require('./utils');

var _misc = require('./misc');

var _helper = require('../utils/helper');

var _analytics = require('../utils/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _maps = require('./maps');

var _graphQL = require('../utils/graphQL');

var _graphQL2 = _interopRequireDefault(_graphQL);

var _constants = require('../utils/constants');

var _transform = require('../utils/transform');

var _transform2 = require('../../lib/utils/transform');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function loadPopularSuggestions(componentId) {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config,
        appbaseRef = _getState.appbaseRef,
        props = _getState.props,
        internalValues = _getState.internalValues;

    var isAppbaseEnabled = config && config.enableAppbase;
    var componentProps = props[componentId] || {};
    var internalValue = internalValues[componentId];
    var value = internalValue && internalValue.value || '';

    if (isAppbaseEnabled && (componentProps.enablePopularSuggestions || componentProps.enableQuerySuggestions)) {
      if (config.mongodb) {
        dispatch((0, _misc.setDefaultPopularSuggestions)([], componentId.split('__internal')[0]));
        return;
      }

      var suggQuery = (0, _utils.getSuggestionQuery)(getState, componentId);
      appbaseRef.getQuerySuggestions(suggQuery).then(function (suggestions) {
        var querySuggestion = suggestions[(0, _utils.getQuerySuggestionsId)(componentId)];

        if (value) {
          dispatch((0, _misc.setPopularSuggestions)(querySuggestion && querySuggestion.hits && querySuggestion.hits.hits, componentId.split('__internal')[0]));
        } else {
          dispatch((0, _misc.setDefaultPopularSuggestions)(querySuggestion && querySuggestion.hits && querySuggestion.hits.hits, componentId.split('__internal')[0]));
        }
      }).catch(function (e) {
        (0, _utils.handleError)({
          orderOfQueries: [componentId],
          error: e
        }, getState, dispatch);
      });
    }
  };
}

var handleTransformRequest = function handleTransformRequest(transformRequest, res) {
  if (transformRequest && typeof transformRequest === 'function') {
    var transformRequestPromise = transformRequest(res);
    return transformRequestPromise instanceof Promise ? transformRequestPromise : Promise.resolve(transformRequestPromise);
  }

  return Promise.resolve(res);
};

function msearch(query, orderOfQueries) {
  var appendToHits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isInternalComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var appendToAggs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var componentType = arguments[5];
  return function (dispatch, getState) {
    var _getState2 = getState(),
        appbaseRef = _getState2.appbaseRef,
        config = _getState2.config,
        headers = _getState2.headers,
        analytics = _getState2.analytics,
        selectedValues = _getState2.selectedValues;

    var searchHeaders = {};
    var suggestionsComponents = [_constants.componentTypes.dataSearch, _constants.componentTypes.categorySearch];
    var isSuggestionsQuery = isInternalComponent && suggestionsComponents.indexOf(componentType) !== -1;

    if (config.analytics) {
      if (config.analyticsConfig.suggestionAnalytics && isSuggestionsQuery) {
        var suggestionsSearchValue = analytics.suggestionsSearchValue;
        var shouldIncludeQuery = !!(config.analyticsConfig.emptyQuery || suggestionsSearchValue);

        if (shouldIncludeQuery) {
          searchHeaders = {
            'X-Search-Query': suggestionsSearchValue || ''
          };
        }
      } else {
        var searchValue = analytics.searchValue,
            searchId = analytics.searchId;
        var filterString = (0, _analytics2.default)(selectedValues);

        if (searchId) {
          searchHeaders = _extends({
            'X-Search-Id': searchId,
            'X-Search-Query': searchValue || ''
          }, filterString && {
            'X-Search-Filters': filterString
          });
        } else {
          var _shouldIncludeQuery = !!(config.analyticsConfig.emptyQuery || searchValue);

          searchHeaders = _extends(_shouldIncludeQuery && {
            'X-Search-Query': searchValue || ''
          }, filterString && {
            'X-Search-Filters': filterString
          });
        }
      }

      if (config.analyticsConfig.userId) {
        searchHeaders['X-User-Id'] = config.analyticsConfig.userId;
      }

      if (config.analyticsConfig.customEvents) {
        searchHeaders['X-Search-CustomEvent'] = (0, _analytics.parseCustomEvents)(config.analyticsConfig.customEvents);
      }
    }

    orderOfQueries.forEach(function (component) {
      dispatch((0, _misc.setLoading)(component, true));
      dispatch((0, _misc.setError)(component, null));
    });

    if (config.graphQLUrl) {
      var requestOptions = {
        graphQLUrl: config.graphQLUrl,
        url: config.url,
        credentials: config.credentials,
        app: config.app,
        query: query,
        headers: headers
      };
      handleTransformRequest(appbaseRef.transformRequest, requestOptions).then(function (modifiedRequest) {
        (0, _graphQL2.default)(modifiedRequest).then(function (res) {
          (0, _utils.handleResponseMSearch)({
            res: res,
            isSuggestionsQuery: isSuggestionsQuery,
            orderOfQueries: orderOfQueries,
            appendToHits: appendToHits,
            appendToAggs: appendToAggs
          }, getState, dispatch);
        }).catch(function (err) {
          (0, _utils.handleError)({
            orderOfQueries: orderOfQueries,
            error: err
          }, getState, dispatch);
        });
      }).catch(function (err) {
        (0, _utils.handleError)({
          orderOfQueries: orderOfQueries,
          error: err
        }, getState, dispatch);
      });
    } else {
      appbaseRef.setHeaders(_extends({}, headers, searchHeaders));
      appbaseRef.msearch({
        type: config.type === '*' ? '' : config.type,
        body: query
      }).then(function (res) {
        (0, _utils.handleResponseMSearch)({
          res: res,
          isSuggestionsQuery: isSuggestionsQuery,
          orderOfQueries: orderOfQueries,
          appendToHits: appendToHits,
          appendToAggs: appendToAggs
        }, getState, dispatch);
      }).catch(function (err) {
        (0, _utils.handleError)({
          orderOfQueries: orderOfQueries,
          error: err
        }, getState, dispatch);
      });
    }
  };
}

function appbaseSearch() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      query = _ref.query,
      orderOfQueries = _ref.orderOfQueries,
      _ref$appendToHits = _ref.appendToHits,
      appendToHits = _ref$appendToHits === undefined ? false : _ref$appendToHits,
      _ref$isSuggestionsQue = _ref.isSuggestionsQuery,
      isSuggestionsQuery = _ref$isSuggestionsQue === undefined ? false : _ref$isSuggestionsQue,
      searchComponentID = _ref.searchComponentID,
      _ref$appendToAggs = _ref.appendToAggs,
      appendToAggs = _ref$appendToAggs === undefined ? false : _ref$appendToAggs;

  return function (dispatch, getState) {
    var _getState3 = getState(),
        appbaseRef = _getState3.appbaseRef,
        config = _getState3.config,
        headers = _getState3.headers;

    var isAnalyticsEnabled = false;

    if (config) {
      if ((0, _utils.isPropertyDefined)(config.analytics)) {
        isAnalyticsEnabled = config.analytics;
      } else if (config.analyticsConfig) {
        if ((0, _utils.isPropertyDefined)(config.analyticsConfig.recordAnalytics)) {
          isAnalyticsEnabled = config.analyticsConfig.recordAnalytics;
        } else if ((0, _utils.isPropertyDefined)(config.analyticsConfig.analytics)) {
          isAnalyticsEnabled = config.analyticsConfig.analytics;
        }
      }
    }

    var settings = {
      recordAnalytics: isAnalyticsEnabled
    };

    if (config.analyticsConfig) {
      settings.userId = (0, _utils.isPropertyDefined)(config.analyticsConfig.userId) ? config.analyticsConfig.userId : undefined;
      settings.enableQueryRules = (0, _utils.isPropertyDefined)(config.analyticsConfig.enableQueryRules) ? config.analyticsConfig.enableQueryRules : undefined;
      settings.customEvents = (0, _utils.isPropertyDefined)(config.analyticsConfig.customEvents) ? config.analyticsConfig.customEvents : undefined;
    }

    orderOfQueries.forEach(function (component) {
      dispatch((0, _misc.setLoading)(component, true));
      dispatch((0, _misc.setError)(component, null));
    });
    appbaseRef.setHeaders(_extends({}, headers));

    if (isSuggestionsQuery && searchComponentID) {
      dispatch(loadPopularSuggestions(searchComponentID));
    }

    appbaseRef.reactiveSearchv3(query, settings).then(function (res) {
      (0, _utils.handleResponse)({
        res: res,
        orderOfQueries: orderOfQueries,
        appendToHits: appendToHits,
        appendToAggs: appendToAggs,
        query: query
      }, getState, dispatch);
    }).catch(function (err) {
      (0, _utils.handleError)({
        orderOfQueries: orderOfQueries,
        error: err
      }, getState, dispatch);
    });
  };
}

var requestStack = [];
var lock = false;

function executeQuery(componentId) {
  var executeWatchList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mustExecuteMapQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var componentType = arguments[3];
  var metaOptions = arguments[4];
  return function (dispatch, getState) {
    var _getState4 = getState(),
        queryLog = _getState4.queryLog,
        config = _getState4.config,
        mapData = _getState4.mapData,
        watchMan = _getState4.watchMan,
        dependencyTree = _getState4.dependencyTree,
        queryList = _getState4.queryList,
        queryOptions = _getState4.queryOptions,
        queryListener = _getState4.queryListener,
        props = _getState4.props,
        internalValues = _getState4.internalValues;

    var lockTime = config.initialQueriesSyncTime;
    var initialTimestamp = config.initialTimestamp;

    if (config.queryLockConfig instanceof Object) {
      lockTime = config.queryLockConfig.lockTime;
      initialTimestamp = config.queryLockConfig.initialTimestamp;
    }

    var componentList = [componentId];
    var finalQuery = [];
    var appbaseQuery = {};
    var orderOfQueries = [];
    var isAppbaseEnabled = config && config.enableAppbase;

    if (executeWatchList) {
      var watchList = watchMan[componentId] || [];
      componentList = [].concat(_toConsumableArray(componentList), _toConsumableArray(watchList));
    }

    var matchAllQuery = {
      match_all: {}
    };
    componentList.forEach(function (component) {
      var _buildQuery = (0, _helper.buildQuery)(component, dependencyTree, queryList, queryOptions),
          queryObj = _buildQuery.queryObj,
          options = _buildQuery.options;

      var validOptions = ['aggs', 'from', 'sort'];

      if (queryObj && !!Object.keys(queryObj).length || options && Object.keys(options).some(function (item) {
        return validOptions.includes(item);
      })) {
        if (!queryObj || queryObj && !Object.keys(queryObj).length) {
          queryObj = _extends({}, matchAllQuery);
        }

        var currentQuery = _extends({
          query: _extends({}, queryObj)
        }, options, queryOptions[component]);

        var queryToLog = _extends({
          query: _extends({}, queryObj)
        }, options, queryOptions[component]);

        var oldQuery = queryLog[component];

        if (mustExecuteMapQuery || !(0, _helper.compareQueries)(currentQuery, oldQuery, false)) {
          orderOfQueries = [].concat(_toConsumableArray(orderOfQueries), [component]);
          dispatch((0, _misc.logQuery)(component, queryToLog));
          var isMapComponent = Object.keys(mapData).includes(component);

          if (isMapComponent && mapData[component].query) {
            var existingQuery = currentQuery.query;
            currentQuery.query = {
              bool: {
                must: [existingQuery, mapData[component].query]
              }
            };

            if (!mapData[component].persistMapQuery) {
              dispatch((0, _maps.updateMapData)(componentId, null, false));
            }

            var _getState5 = getState(),
                combinedLog = _getState5.combinedLog;

            if ((0, _helper.compareQueries)(combinedLog[component], currentQuery)) return;
            dispatch((0, _misc.logCombinedQuery)(component, currentQuery));
          }

          (0, _utils.executeQueryListener)(queryListener[component], oldQuery, currentQuery);

          if (isAppbaseEnabled) {
            var value = void 0;
            var isInternalComponent = componentId.endsWith('__internal');
            var mainComponentProps = props[componentId];

            if (isInternalComponent && mainComponentProps && (0, _transform.isSearchComponent)(mainComponentProps.componentType)) {
              value = internalValues[componentId] && internalValues[componentId].value;
            }

            var query = (0, _transform.getRSQuery)(component, (0, _transform.extractPropsFromState)(getState(), component, _extends({}, value ? {
              value: value
            } : null, metaOptions ? {
              from: metaOptions.from
            } : null)));

            if (query) {
              appbaseQuery = _extends({}, appbaseQuery, _defineProperty({}, component, query), (0, _transform.getDependentQueries)(getState(), component, orderOfQueries));
            }

            if (isMapComponent) {
              var internalComponent = (0, _transform2.getInternalComponentID)(component);
              var internalQuery = (0, _transform.getRSQuery)(internalComponent, (0, _transform.extractPropsFromState)(getState(), internalComponent, metaOptions ? {
                from: metaOptions.from
              } : null));

              if (internalQuery) {
                appbaseQuery[internalComponent] = _extends({}, internalQuery, {
                  execute: false
                });
              }
            }
          } else {
            var preference = config && config.analyticsConfig && config.analyticsConfig.userId ? config.analyticsConfig.userId + '_' + component : component;
            finalQuery = [].concat(_toConsumableArray(finalQuery), [{
              preference: preference
            }, currentQuery]);
          }
        }
      }
    });

    if (isAppbaseEnabled) {
      finalQuery = Object.keys(appbaseQuery).map(function (component) {
        return appbaseQuery[component];
      });
    }

    if (finalQuery.length) {
      if (isAppbaseEnabled) {
        var suggestionsComponents = [_constants.componentTypes.dataSearch, _constants.componentTypes.categorySearch];
        var isInternalComponent = componentId.endsWith('__internal');
        var isSuggestionsQuery = isInternalComponent && suggestionsComponents.indexOf(componentType) !== -1;
        var currentTime = new Date().getTime();

        if (currentTime - initialTimestamp < lockTime) {
          if (!lock || config.queryLockConfig) {
            setTimeout(function () {
              var finalOrderOfQueries = [];
              var finalIsSuggestionsQuery = false;
              var finalSearchComponentID = '';
              var orderOfQueriesMap = {};
              var processedQueriesMap = {};
              var queryExecutionMap = {};
              requestStack.forEach(function (request) {
                if (!finalIsSuggestionsQuery) {
                  finalIsSuggestionsQuery = request.isSuggestionsQuery;
                }

                if (!finalSearchComponentID) {
                  finalSearchComponentID = request.searchComponentID;
                }

                if (Array.isArray(request.query)) {
                  request.query.forEach(function (query) {
                    if (query.execute) {
                      queryExecutionMap[query.id] = query.execute;
                    }

                    var newQuery = query;

                    if (queryExecutionMap[query.id]) {
                      newQuery.execute = true;
                    }

                    processedQueriesMap[query.id] = newQuery;
                  });
                }

                if (Array.isArray(request.orderOfQueries)) {
                  request.orderOfQueries.forEach(function (query) {
                    if (!orderOfQueriesMap[query.id]) {
                      finalOrderOfQueries = [query].concat(_toConsumableArray(finalOrderOfQueries));
                    } else {
                      orderOfQueriesMap[query.id] = true;
                    }
                  });
                }
              });
              var finalCombinedQuery = Object.values(processedQueriesMap);

              if (finalCombinedQuery.length) {
                dispatch(appbaseSearch({
                  query: finalCombinedQuery,
                  orderOfQueries: finalOrderOfQueries,
                  isSuggestionsQuery: finalIsSuggestionsQuery,
                  searchComponentID: finalSearchComponentID
                }));
              }

              requestStack = [];
              dispatch((0, _utils.updateStoreConfig)({
                queryLockConfig: undefined
              }));
            }, lockTime);
          }

          lock = true;
          requestStack.push({
            query: finalQuery,
            orderOfQueries: orderOfQueries,
            isSuggestionsQuery: isSuggestionsQuery,
            searchComponentID: componentId
          });
        } else {
          dispatch(appbaseSearch({
            query: finalQuery,
            orderOfQueries: orderOfQueries,
            isSuggestionsQuery: isSuggestionsQuery,
            searchComponentID: componentId
          }));
        }
      } else {
        dispatch(msearch(finalQuery, orderOfQueries, false, componentId.endsWith('__internal'), undefined, componentType));
      }
    }
  };
}

function setQueryOptions(component, queryOptions) {
  var execute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    dispatch((0, _misc.updateQueryOptions)(component, queryOptions));

    if (execute) {
      dispatch(executeQuery(component, true));
    }
  };
}

function updateQuery(_ref2) {
  var componentId = _ref2.componentId,
      query = _ref2.query,
      value = _ref2.value,
      _ref2$label = _ref2.label,
      label = _ref2$label === undefined ? null : _ref2$label,
      _ref2$showFilter = _ref2.showFilter,
      showFilter = _ref2$showFilter === undefined ? true : _ref2$showFilter,
      _ref2$URLParams = _ref2.URLParams,
      URLParams = _ref2$URLParams === undefined ? false : _ref2$URLParams,
      _ref2$componentType = _ref2.componentType,
      componentType = _ref2$componentType === undefined ? null : _ref2$componentType,
      _ref2$category = _ref2.category,
      category = _ref2$category === undefined ? null : _ref2$category,
      _ref2$meta = _ref2.meta,
      meta = _ref2$meta === undefined ? {} : _ref2$meta;
  var execute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var shouldSetInternalValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    var queryToDispatch = query;

    if (query && query.query) {
      queryToDispatch = query.query;
    }

    if (!componentId.endsWith('__internal')) {
      dispatch((0, _value.setValue)(componentId, value, label, showFilter, URLParams, componentType, category, meta));

      if (shouldSetInternalValue) {
        if (componentType === _constants.componentTypes.dynamicRangeSlider) {
          dispatch((0, _value.setInternalValue)((0, _transform.getHistogramComponentID)(componentId), value, componentType, category, meta));
        } else {
          dispatch((0, _value.setInternalValue)(componentId + '__internal', value, componentType, category, meta));
        }
      }
    } else {
      dispatch((0, _value.setInternalValue)(componentId, value, componentType, category, meta));
    }

    dispatch((0, _misc.setQuery)(componentId, queryToDispatch));
    if (execute) dispatch(executeQuery(componentId, true, false, componentType));
  };
}

function loadMore(component, newOptions) {
  var appendToHits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var appendToAggs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    var store = getState();

    var _buildQuery2 = (0, _helper.buildQuery)(component, store.dependencyTree, store.queryList, store.queryOptions),
        queryObj = _buildQuery2.queryObj,
        options = _buildQuery2.options;

    var queryLog = store.queryLog;
    if (!options) options = {};
    options = _extends({}, options, newOptions);

    if (!queryObj || queryObj && !Object.keys(queryObj).length) {
      queryObj = {
        match_all: {}
      };
    }

    var currentQuery = _extends({
      query: _extends({}, queryObj)
    }, options);

    if ((0, _helper.compareQueries)(queryLog[component], currentQuery)) return;
    dispatch((0, _misc.logQuery)(component, currentQuery));

    if (store.config && store.config.enableAppbase) {
      var appbaseQuery = {};
      var componentProps = store.props[component] || {};
      var compositeAggregationField = componentProps.aggregationField;
      var queryType = _transform.componentToTypeMap[componentProps.componentType];

      if (queryType === _constants.queryTypes.term) {
        compositeAggregationField = componentProps.dataField;
      }

      var query = (0, _transform.getRSQuery)(component, (0, _transform.extractPropsFromState)(store, component, {
        from: options.from,
        after: store.aggregations[component] && store.aggregations[component][compositeAggregationField] && store.aggregations[component][compositeAggregationField].after_key || undefined
      }));
      appbaseQuery = _extends(_defineProperty({}, component, query), (0, _transform.getDependentQueries)(getState(), component, []));
      var finalQuery = Object.keys(appbaseQuery).map(function (c) {
        return appbaseQuery[c];
      });
      dispatch(appbaseSearch({
        query: finalQuery,
        orderOfQueries: [component],
        appendToHits: appendToHits,
        appendToAggs: appendToAggs
      }));
    } else {
      var preference = store.config && store.config.analyticsConfig && store.config.analyticsConfig.userId ? store.config.analyticsConfig.userId + '_' + component : component;
      var _finalQuery = [{
        preference: preference
      }, currentQuery];
      dispatch(msearch(_finalQuery, [component], appendToHits, false, appendToAggs));
    }
  };
}

function loadDataToExport(componentId) {
  var deepPaginationCursor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var totalResults = arguments[2];
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return function (dispatch, getState) {
    var _getState6 = getState(),
        appbaseRef = _getState6.appbaseRef,
        lastUsedAppbaseQuery = _getState6.lastUsedAppbaseQuery;

    var queryFromStore = lastUsedAppbaseQuery[componentId];

    if (queryFromStore) {
      var query = queryFromStore.map(function (queryItem) {
        if (queryItem.id === componentId) {
          return _extends({}, queryItem, {
            deepPaginationConfig: {
              cursor: deepPaginationCursor
            },
            deepPagination: true,
            size: totalResults < 1000 ? totalResults : 1000,
            sortField: '_id',
            sortBy: 'asc'
          });
        }

        return queryItem;
      });

      if (totalResults && Array.isArray(data) && totalResults <= data.length) {
        return data;
      }

      return appbaseRef.reactiveSearchv3(query).then(function (res) {
        var newDataChunk = res[componentId].hits.hits;
        return dispatch(loadDataToExport(componentId, newDataChunk[newDataChunk.length - 1]._id, res[componentId].hits.total.value, [].concat(_toConsumableArray(data), _toConsumableArray(newDataChunk))));
      }).catch(function (err) {
        console.error('Error fetching data to export! ', err);
      });
    }

    return console.error('Error fetching data to export!');
  };
}